import React, { useState, useContext, useEffect } from "react";
import {Button, Card, CardContent, FormControl, Grid, TextField, MenuItem, Select, InputLabel, FormHelperText
} from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import deLocale from "date-fns/locale/es";
import { useForm, Controller } from "react-hook-form";
import { useStateValue } from "../../context/store";
import { styles } from "../styles";
import { yupResolver } from "@hookform/resolvers/yup";
import Utils from "../../utils/utils";
import * as yup from "yup";
import { DataContext } from "../../context/reducers/contextSearchUser";

const defaultValue = {
  documentType: "",
}

const UserSearch = ({  maestras, charges }) => {

  const {setOpenEdit} = useContext(DataContext);

  const classes = styles();
  var currentDate = new Date();

  const [minDate, setMinDate] = useState(null);
  const [maxDate, setMaxDate] = useState(
    Utils.getFormattedDateMMddyyyy(currentDate, ".")
  );
  const [maxInitDate, setMaxInitDate] = useState(
    Utils.getFormattedDateMMddyyyy(currentDate, ".")
  );
  const [{}, dispatch] = useStateValue();
  const [dateError, setDateError] = useState(false);
  const [dateErrorMessage, setDateErrorMessage] = useState('')
  const errorFechaInferior = 'Ingrese una fecha inferior a la fecha final';
  const [validateNumber, setValidateNumber] = useState(false);
  const [vNumberIdent, setVNumberIdent] = useState(false);
  const [vEmail, setVEmail] = useState(false);
  const [vFirstName, setVFirstName] = useState(false);
  const [vSurname, setVSurname] = useState(false);
  const [defaultValues, setDefaultValues] = useState(defaultValue);

  const schema = yup.object().shape({
    email: vEmail
      ? null
      : yup.string()
        .notRequired()
        .email("Ingrese un correo electrónico válido")
        .min(8, "Ingrese mínimo 8 caracteres")
        .max(50, "Ingrese máximo 50 caracteres"),
    firstName: vFirstName
      ? null
      : yup.string()
        .notRequired()
        .min(3, "Ingrese mínimo 3 caracteres")
        .max(50, "Ingrese máximo 50 caracteres")
        .matches(
          /^(([A-Za-zÀ-ÿ])+[ ]?)*$/g,
          "Ingrese un nombre válido"
        ),
    surname: vSurname
      ? null
      : yup.string()
        .notRequired()
        .min(3, "Ingrese mínimo 3 caracteres")
        .max(50, "Ingrese máximo 50 caracteres")
        .matches(
          /^(([A-Za-zÀ-ÿ])+[ ]?)*$/g,
          "Ingrese un apellido válido"
        ),
    documentType: yup.string()
      .nullable()
      .notRequired(),
    document: vNumberIdent
      ? null
      : validateNumber
        ? yup
          .string()
          .notRequired()
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(16, "Ingrese máximo 16 caracteres")
          .matches(
            /^([0-9A-Za-zÑñ]{0,16})$/,
            "Ingrese un número de identificación válido"
          )
        : yup
          .string()
          .notRequired()
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(16, "Ingrese máximo 16 caracteres")
          .matches(
            /^([0-9]{0,16})$/,
            "Ingrese un número de identificación válido"
          ),
    type: yup.string()
      .notRequired(),
    status: yup.string()
      .notRequired(),
    initDate: yup
      .date()
      .typeError("Formato de fecha inválido")
      .when([], {
        is: (initDate) => initDate && initDate.length > 0,
        then: yup
          .date()
          .typeError("Formato de fecha inválido")
          .nullable(true)
          .notRequired(),
        otherwise: yup
          .date()
          .typeError("Formato de fecha inválido")
          .nullable(true)
          .notRequired(),
      }),
    endDate: yup
      .date()
      .typeError("Formato de fecha inválido")
      .when([], {
        is: (endDate) => endDate && endDate.length > 0,
        then: yup
          .date()
          .typeError("Formato de fecha inválido")
          .nullable(true)
          .notRequired(),
        otherwise: yup
          .date()
          .typeError("Formato de fecha inválido")
          .nullable(true)
          .notRequired(),
      }),
      chargeDenomination: yup.string()
        .notRequired()

  });

  const { register, handleSubmit, setValue, control, errors, getValues, watch } =
    useForm({
      resolver: yupResolver(schema),
      defaultValue,
      mode: "all",
      reValidateMode: "onChange",
    });

    const onChangeDate = (value) => {
      setMinDate(value);
    };

    const updateMaxInitDate = (date) => {
      var currentData = getValues();
      if (!currentData.initDate) {
        setMaxInitDate(date);
      } else {
        setMaxInitDate(Utils.getFormattedDateMMddyyyy(currentDate, "."));
      }
    };

    const validateMaxInitDate = () => {
      var currentData = getValues();
      if (!currentData.endDate) {
        setMaxInitDate(Utils.getFormattedDateMMddyyyy(currentDate, "."));
      } else {
        setMaxInitDate(Utils.getFormattedDateMMddyyyy(currentData.endDate, "."));
      }
    };

    const onSubmit = (data) => {
      setOpenEdit(false);
      const newData = {...data, username:data.email, }
      if (
        newData.email !== null ||
        newData.firstName !== null ||
        newData.surname !== null ||
        newData.document !== null ||
        newData.documentType !== null ||
        newData.type !== null ||
        newData.status !== null ||
        newData.initDate !==  null ||
        newData.endDate !==  null ||
        newData.chargeDenomination !== null
      ) {
        if (data.initDate > data.endDate) {
          setDateError(true);
          setDateErrorMessage(errorFechaInferior);
          return;
        } else {
          setDateError(false);
          setDateErrorMessage("");
        }
        dispatch({
          type: "SET_FILTER",
          filter: newData,
          isFilter: true,
        });
      }
    };

    const clearForm = () => {
      /* setValue("email", null);
      setValue("firstName", null);
      setValue("surname", null);
      setValue("document", null);
      setValue("documentType", "");
      setValue("status", "");
      setValue("initDate", null);
      setValue("type", "");
      setValue("endDate", null);
      setValue("chargeDenomination", "");
      setDateError(false);
      setDateErrorMessage("");
      setMaxInitDate( new Date());
      setMinDate(null);
      setDefaultValues(""); */
      window.location.reload();
    };

  const clearBtn = () => {
    clearForm();
    dispatch({
      type: "SET_FILTER",
      filter: {
        username: null,
        email: null,
        firstName: null,
        surname: null,
        document: null,
        documentType: "",
        status: null,
        type: null,
        initDate: null,
        endDate: null,
        chargeDenomination: null,
    },
    isFilter: true,
    });
  };

  const handleTypeDocument = (e) => {
    const {name, value} = e.target;
    setDefaultValues({...defaultValues, [name] : value,})
    if(valueTypeDocument){
      setValue("document", "");
    }
  }

  const handleUserKeyPress = (e) => {
    var form = getValues();
    if (form.documentType !== "PP") {
      let validChars = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
      if (!validChars.includes(e.key)) {
        e.preventDefault();
      }
    }
  };

  const valueTypeDocument = (watch("documentType") === "PP");
  const valueDocument = watch("document");
  const valueEmail = watch("email");
  const valueFirstName = watch("firstName");
  const valueSurname = watch("surname");

  useEffect(() => {
    if(valueEmail === ""){
      setVEmail(true);
    }else{
      setVEmail(false);
    }

    if(valueDocument === ""){
      setVNumberIdent(true);
    }else{
      setVNumberIdent(false);
    }

    if(valueTypeDocument){
    //setValue("document", "")
      setValidateNumber(true);
    }else{
      setValidateNumber(false);
    }

    if(valueFirstName === ""){
      setVFirstName(true);
    }else{
      setVFirstName(false);
    }

    if(valueSurname === ""){
      setVSurname(true);
    }else{
      setVSurname(false);
    }

  }, [ valueEmail, valueTypeDocument, valueDocument, valueFirstName, valueSurname, validateNumber, watch])

  return (
    <Card elevation = {0} style={{background: '#e0f2f7', marginLeft: -15}} >
      <CardContent>
        <form  onSubmit={handleSubmit(onSubmit)} className={classes.form} autocomplete="off">
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              <FormControl fullWidth>
                <TextField
                  fullWidth
                  variant="outlined"
                  inputRef={register}
                  InputLabelProps = {{ shrink: true}}
                  className = {classes.dropdown}
                  type="text"
                  autocomplete="off"
                  label="Correo electrónico"
                  name="email"
                  size="small"
                  error={ valueEmail !== ""
                    ? errors.hasOwnProperty("email") && errors["email"].message
                    : null
                  }
                />
                <FormHelperText style={{color: "#f44336", paddingLeft: 14}}>
                  {valueEmail !== ""
                      ? errors.hasOwnProperty("email") && errors["email"].message
                      : null
                  }
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>

              <FormControl
                variant="outlined"
                fullWidth
                size="small"
                error={
                  !!errors.hasOwnProperty("documentType") &&
                  errors["documentType"].message

                }
              >
                <InputLabel htmlFor="outlined-select-documentType" shrink={true}>
                  Tipo de documento
                </InputLabel>
                <Controller
                  fullWidth
                  control={control}
                  inputRef={register}
                  name="documentType"
                  defaultValue=""
                  size="small"
                  render={(props) => (
                    <Select
                      label="Tipo de Documento"
                      notched={true}
                      className={classes.dropdown}
                      inputProps={{
                        name: "documentType",
                        id: "outlined-select-documentType",
                      }}
                      onChange={(e) => {
                        props.onChange(e);
                        handleTypeDocument(e);
                      }}
                    >
                      {maestras.tipoDocumnetoIdentificacion.map(
                        (document) => (
                        <MenuItem
                          className={classes.menuItem}
                          key={document.key}
                          value={document.key}
                        >
                          {document.value}
                        </MenuItem>
                      )
                    )}
                    </Select>
                  )}
                />

                <FormHelperText>
                  {errors.hasOwnProperty("documentType") && errors["documentType"].message}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <FormControl fullWidth>
              <TextField
                InputLabelProps={{ shrink: true }}
                inputRef={register}
                type="text"
                name="document"
                className = {classes.dropdown}
                defaultValue=""
                variant="outlined"
                fullWidth
                size="small"
                label="Número de Documento"
                error={valueDocument === ""
                  ? null
                  : errors.hasOwnProperty("document") && errors["document"].message
                }
                onKeyPress={handleUserKeyPress}
              />
              <FormHelperText style={{color: "#f44336", paddingLeft: 14}}>
                {valueDocument !== ""
                  ? errors.hasOwnProperty("document") && errors["document"].message
                  : null
                }
              </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <FormControl fullWidth>
                <TextField
                  fullWidth
                  variant="outlined"
                  inputRef={register}
                  InputLabelProps = {{ shrink: true}}
                  className = {classes.dropdown}
                  type="text"
                  autocomplete="off"
                  label="Primer Nombre"
                  name="firstName"
                  size="small"
                  error={valueFirstName !== ""
                    ? errors.hasOwnProperty("firstName") && errors["firstName"].message
                    : null
                  }
                />
                <FormHelperText style={{color: "#f44336", paddingLeft: 14}}>
                  {valueFirstName !==""
                    ? errors.hasOwnProperty("firstName") && errors["firstName"].message
                    : null
                  }
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <FormControl fullWidth>
                <TextField
                  fullWidth
                  inputRef={register}
                  variant="outlined"
                  InputLabelProps = {{ shrink: true}}
                  className = {classes.dropdown}
                  type="text"
                  autocomplete="off"
                  label="Primer Apellido"
                  name="surname"
                  size="small"
                  error={valueSurname !==""
                    ? errors.hasOwnProperty("surname") && errors["surname"].message
                    : null
                  }
                />
                <FormHelperText style={{color: "#f44336", paddingLeft: 14}}>
                  {valueSurname !== ""
                    ? errors.hasOwnProperty("surname") && errors["surname"].message
                    : null
                  }
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
            <FormControl  variant="outlined" fullWidth  size="small" >
              <InputLabel htmlFor="outlined-select-estado" shrink={true} size="small" >Estado</InputLabel>
              <Controller
              control={control}
              inputRef={register}
              fullWidth
              size="small"

              className = {classes.dropdown}
              label = "Estado"
              notched={true}
              name = "status"
              defaultValue=""
              inputProps = {
                  {
                      name: 'status',
                      id: 'outlined-select-estado',
                  }
              }
              as={
              <Select >
                  <MenuItem
                      className={classes.menuItem}
                      key = {1}
                      value = "ACTIVO"
                  >
                    Activo
                  </MenuItem>
                  <MenuItem
                      className={classes.menuItem}
                      key = {2}
                      value = "INACTIVO"
                  >
                    Inactivo
                  </MenuItem>
              </Select>
              }
              />
            </FormControl>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                <Controller
                  as={
                    <KeyboardDatePicker
                      fullWidth
                      inputVariant="outlined"
                      variant="inline"
                      format="dd/MM/yyyy"
                      className = {classes.dropdown}
                      dateFormat="DD/MM/YYYY"
                      label="Desde"
                      InputLabelProps={{ shrink: true }}
                      onAccept={onChangeDate}
                      onOpen={validateMaxInitDate}
                      error={
                        !!errors.hasOwnProperty("initDate") &&
                        errors["initDate"].message
                      }
                      helperText={
                        errors.hasOwnProperty("initDate") &&
                        errors["initDate"].message
                      }
                      minDate="01.01.2020"
                      maxDate={maxInitDate}
                    />
                  }
                  control={control}
                  name="initDate"
                  defaultValue={null}
                  placeholder="Desde"
                  size="small"
                />
              </MuiPickersUtilsProvider>
              <FormHelperText style={{ color: "#f44336" }}>
                  {dateError && dateErrorMessage}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                <Controller
                  as={
                    <KeyboardDatePicker
                      fullWidth
                      inputVariant="outlined"
                      variant="inline"
                      format="dd/MM/yyyy"
                      dateFormat="DD/MM/YYYY"
                      className = {classes.dropdown}
                      label="Hasta"
                      InputLabelProps={{ shrink: true }}
                      onAccept={updateMaxInitDate}
                      error={
                        !!errors.hasOwnProperty("endDate") &&
                        errors["endDate"].message
                      }
                      helperText={
                        errors.hasOwnProperty("endDate") &&
                        errors["endDate"].message
                      }
                      minDate={minDate ? minDate : "01.01.2020"}
                      maxDate={maxDate}
                    />
                  }
                  control={control}
                  name="endDate"
                  defaultValue={null}
                  placeholder="Hasta"
                  size="small"
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <FormControl
                variant="outlined"
                fullWidth
                size="small"
                error={
                  !!errors.hasOwnProperty("type") &&
                  errors["type"].message
                }
              >
                <InputLabel
                  htmlFor="outlined-select-type"
                  shrink={true}
                >
                  Tipo de Usuario
                </InputLabel>
                <Controller
                  fullWidth
                  control={control}
                  inputRef={register}
                  className = {classes.dropdown}
                  label="Tipo de Usuario"
                  defaultValue=""
                  name="type"
                  size="small"
                  //onChange={(event) => alert(event.target.value)}
                  notched={true}
                  inputProps={{
                    name: "type",
                    id: "outlined-select-type",
                  }}
                  as={
                    <Select>
                      <MenuItem value="INTERNO">Interno</MenuItem>
                      <MenuItem value="EXTERNO">Externo</MenuItem>

                    </Select>
                  }
                />
                <FormHelperText style={{color: "#f44336", paddingLeft: 14}}>
                  {errors.hasOwnProperty("type") && errors["type"].message}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <FormControl
                variant="outlined"
                fullWidth
                size="small"
                error={
                  !!errors.hasOwnProperty("chargeDenomination") &&
                  errors["chargeDenomination"].message
                }
              >
                <InputLabel
                  htmlFor="outlined-select-chargeDenomination"
                  shrink={true}
                >
                  Cargo
                </InputLabel>
                <Controller
                  fullWidth
                  control={control}
                  inputRef={register}
                  className = {classes.dropdown}
                  label="Cargo"
                  defaultValue=""
                  name="chargeDenomination"
                  size="small"
                  //onChange={(event) => alert(event.target.value)}
                  notched={true}
                  inputProps={{
                    name: "chargeDenomination",
                    id: "outlined-select-chargeDenomination",
                  }}
                  as={
                    <Select>
                      {charges.map(
                        (resp) => (
                          <MenuItem
                            className={classes.menuItem}
                            key={resp.id}
                            value={resp.denomination}
                          >
                            {resp.denomination}
                          </MenuItem>
                        )
                      )}
                    </Select>
                  }
                />
                <FormHelperText style={{color: "#f44336", paddingLeft: 14}}>
                  {errors.hasOwnProperty("chargeDenomination") && errors["chargeDenomination"].message}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <Button
                variant="contained"
                className={classes.buttonSearch}
                type="submit"
              >
                Buscar
              </Button>
              &nbsp;&nbsp;
              <Button
                className={classes.buttonSearch}
                onClick={clearBtn}
              >
                Limpiar
              </Button>
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </Card>
  );
};

export default UserSearch;
